<template>
    <el-dialog
            title="选择供应商"
            :visible="showFlag"
            width="30%"
            append-to-body
            @close="closeDialog"
    >
        <div class="operation-bar">
            <el-button type="text" style="margin-left: 10px" @click="clearSelect">清空</el-button>
            <div class="operation-bar-right">
                <div class="input-box">
                    <i class="el-icon-search" @click="queryData"></i>
                    <input type="text" v-model="keyword" placeholder="请输入供应商编码或名称"/>
                </div>
            </div>
        </div>

        <el-table :data="vendorList" height="381px" width="100%" highlight-current-row @current-change="handleCurrentRowChange">
            <el-table-column  type="index" width="50" label="序号" align="center" header-align="center"></el-table-column>
            <el-table-column prop="vendorNo"  width="150" label="编码" align="center" header-align="center"></el-table-column>
            <el-table-column prop="vendorName" label="名称" align="center" header-align="center" :show-overflow-tooltip="true"></el-table-column>
<!--            <el-table-column prop="stamp" label="签章" align="center" header-align="center">-->
<!--                <template slot-scope="scope">-->
<!--                    <img :src="scope.row.stamp? 'data:image/jpg;base64,' + scope.row.stamp : '' " width="20px">-->
<!--                </template>-->
<!--            </el-table-column>-->
        </el-table>
        <div class="table-page">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-sizes="page.pageSizes"
                    :page-size="page.pageSize"
                    layout="total, prev, pager, next"
                    :total="page.total">
            </el-pagination>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submitSelect">确定</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {mapState} from 'vuex';
    export default {
        name: 'selectVendorDialog',
        computed: {
            ...mapState('system/vendorManagement', ['vendorList', 'page'])
        },
        props: {
            showFlag: false
        },
        watch: {
            showFlag(newVal, oldVal) {
                if(newVal){
                    this.loadData();
                }
            }
        },
        data() {
            return {
                keyword: '',
                vendor: {
                    pkSupplier: '',
                    vendorName: ''
                },
                selectVendor: {}
            }
        },
        methods: {
            clearSelect() {
                this.$emit('clearSearchVendor');
                this.closeDialog();
            },
            submitSelect() {
                this.$emit('selectVendor', this.selectVendor);
                this.vendor.pkSupplier = this.selectVendor.id;
                this.vendor.vendorName = this.selectVendor.vendorName;
                this.closeDialog()
            },
            handleCurrentRowChange(val) {
                this.selectVendor = val;
            },
            handleCurrentChange(val) {
                this.$store.dispatch('system/vendorManagement/setPageCurrent',val);
                this.loadData();
            },
            handleSizeChange(val) {
                this.$store.dispatch('system/vendorManagement/setPageSize',val);
                this.loadData();
            },
            queryData() {
                //查询数据
                this.$store.dispatch('system/vendorManagement/setPageCurrent',1);
                this.$store.dispatch('system/vendorManagement/getVendorList',this.keyword);
            },
            loadData() {
                //查询数据
                this.$store.dispatch('system/vendorManagement/getVendorList',this.keyword);
            },
            closeDialog() {
                this.keyword = '';
                this.$emit('closeDialog');
            }
        }
    }
</script>
<style scoped>
    .search-box {
        width: 100%;
        position: relative;
        height: 40px;
    }
    .search-box .search-show {
        width: 255px;
        height: 60px;
        position: absolute;
        right: 0;
        top: 0;
    }
    .table-page {
        margin-top: 20px;
        text-align: center;
    }
</style>
